import { type FC } from 'react'

import { useGlobalConfigContext } from '../../../../global-config'
import { priceGetFormattedPercentageDiscount } from '../../../../price'
import { ProductDiscount } from '../../../../product'
import { productSearchAlgoliaAccessorGetDiscountData } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetDiscountData'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'

export const ProductSearchResultItemPriceContainerDiscountBadge: FC = () => {
  const { algoliaRecord: item } = useProductSearchResultItemContext()
  const { discountBoundaries, superScripts, tenant } = useGlobalConfigContext()

  const { discountInPercent, showDiscount } =
    productSearchAlgoliaAccessorGetDiscountData(
      item,
      discountBoundaries,
      tenant,
    )

  return showDiscount ? (
    <ProductDiscount
      className="rounded-full bg-light-tertiary font-mono text-xs font-medium"
      discount={priceGetFormattedPercentageDiscount(discountInPercent)}
      supNote={superScripts.saving}
    />
  ) : null
}
